module.exports = __webpack_public_path__ + "img/logo2.5a87fa6d.png";